// extracted by mini-css-extract-plugin
module.exports = {"header":"notificationList_header__btwrv","readAllBtn":"notificationList_readAllBtn__1r_s5","readAllNotifications":"notificationList_readAllNotifications__aXs0c"};